module.exports = __webpack_public_path__ + "static/media/sid-settings-logo.ed6038f3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sid-settings-logo.svg
// module id = 742
// module chunks = 21